<div class="rd-bulletin repair-diagram-content flex-row" *ngIf="bulletins.length">
  <!-- Dialog Left Side Content -->
  <div class="repair-diagram-content-left">
    <!-- List of Bulletin -->
    <div class="repair-diagram-list flex-column" *ngIf="!isBulletinSelected">
      <div class="repair-diagram-list-item flex-start-center pointer" *ngFor="let bulletin of bulletins"
        (click)="selectedBulletinActive = bulletin; getBulletinDetails(bulletin)" [ngClass]="{'active': bulletin?.applicationId === selectedBulletinActive?.applicationId}">
        <p class="mb-0 flex-column">
          <span class="capitalize">{{bulletin?.displayName}}</span>
          <span>{{bulletin?.description}}</span>
        </p>
      </div>
    </div>

    <!-- List of Bulletin Drilldown if any -->
    <div class="repair-diagram-list flex-column" *ngIf="isBulletinSelected">
      <div class="repair-diagram-list-item flex-start-center pointer" (click)="handleBack()">
        <i class="fal fa-chevron-left p-2"></i>

        <p class="mb-0 font-600 capitalize text-truncate" tooltipPosition="top"
          [pTooltip]="selectedBulletin?.displayName">
          {{selectedBulletin?.displayName}}
        </p>
      </div>

      <div class="repair-diagram-list-item flex-start-center pointer" *ngFor="let option of selectedBulletin?.details">
        <p class="mb-0 font-600 capitalize">
          {{option?.elementRef}} - {{option?.name}}
        </p>
      </div>
    </div>
  </div>

  <!-- Dialog Right Side Content -->
  <div class="repair-diagram-content-right p-2" [hidden]="isLoading">
    <table class="width-100p">
      <thead>
        <th class="font-600 min-width-125 pr-1 pl-1">Type</th>
        <th class="font-600 min-width-125 pr-1 pl-1">Description</th>
        <th class="font-600 min-width-125 pr-1 pl-1">Issue Date</th>
        <th class="font-600 min-width-125 pr-1 pl-1">Manufacturer #</th>
      </thead>

      <tbody>
        <tr *ngFor="let item of selectedBulletin?.items" class="pointer" (click)="openPdf(item.downloadLink)">
          <td class=" pr-1 pl-1">{{item?.type}}</td>
          <td class="pr-1 pl-1">{{item?.description}}</td>
          <td class="pr-1 pl-1">{{item?.issue | date: 'MMM d, yyyy'}}</td>
          <td class="pr-1 pl-1">{{item?.manufacturerNumber}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="repair-diagram-content-right p-2" [hidden]="!isLoading">
    <div class="flex-start-center font-14">
      <span class="pr-2">Loading...</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>
</div>

<div class="rd-bulletin repair-diagram-content" *ngIf="!bulletins.length">
  <div class="flex-center-center bulletins-service flex-column">
    <img src="../../../../../../assets/img/empty-icon-diagrams.svg" alt="" />
    <div class="pr-2 font-12 pt-2 font-gray-35" >There are no bulletins associated with this service.
  </div>
  </div>
</div>
